import { t } from 'i18next'
import * as React from 'react'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../drupal/rendering/inview_utils.mod'
import { titleSplit } from '../utils/helpers'

export const NotFoundPage= () => (
  <main id="a11y-main" className="main main--error main--page">
    <div className="main__inner">
      <article className="page">
        <div className="page__inner">
          <InView
            as="header"
            onChange={(inView) => blockInviewHandler('pageHeader', inView, 'io-page-header', 'inview')}
            triggerOnce={true}
            threshold={0}
            id="io-page-header"
            className="pageheader cf no-image"
          >
            <div className="pageheader__inner">
              <div className="pageheader__content container container--m">
                <div className="pageheader__message">
                  <div className="pageheader__header">
                    <h1 className="pageheader__title title--m">{titleSplit(t('Common:404.Title'))}</h1>
                  </div>
                </div>
              </div>
            </div>
          </InView>
          <div className="page__content">
            <section className="block block--text">
              <div className="block__inner container container--s grid--block">
                <div className="block__content">
                  <div className="block__inner">
                    <div className="text--styled">
                      <p>{t('Common:404.Oops')}</p>
                      <p>{t('Common:404.Error')}</p>
                      <p>{t('Common:404.Text')}</p>
                      <p>
                        {t('Common:404.Return.FirstPart')} <a href="/">{t('Common:404.Return.Link')}</a>{' '}
                        {t('Common:404.Return.LastPart')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </article>
    </div>
  </main>
)
